var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#335C75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2107 15.873L8.91781 15.1576C9.08517 14.9883 9.08517 14.7138 8.91781 14.5444L3.37745 8.9394H15.5714C15.8081 8.9394 16 8.74527 16 8.50583V7.49414C16 7.2547 15.8081 7.06057 15.5714 7.06057H3.37745L8.91781 1.4555C9.08517 1.28619 9.08517 1.01166 8.91781 0.842314L8.2107 0.126984C8.04335 -0.042328 7.77199 -0.042328 7.6046 0.126984L0.125518 7.69341C-0.0418393 7.86272 -0.0418393 8.13725 0.125518 8.3066L7.6046 15.873C7.77196 16.0423 8.04331 16.0423 8.2107 15.873Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow-left.6c7c9124.svg";
export { ForwardRef as ReactComponent };